import * as $ from 'jquery';

class SebelPopUp {
  init = () => {
    const sebelModal: HTMLButtonElement = document.querySelector('.resero-modal.resero-modal--sebel-pop-up');
    
    if (!sebelModal) {
      return;
    }
    const delayTime = sebelModal.getAttribute('data-delay') ? sebelModal.getAttribute('data-delay') : 500;
    

    function handlePopUpClose () {
      $('body').removeClass('resero-modal-open')
      $(sebelModal).addClass("resero-modal--hidden");
    }

    $(".resero-modal__close:not('.resero-modal__custom-close'), .resero-modal__heading__desc a, .resero-modal__region__item .button:not('.-active')").on("click", handlePopUpClose);

  };

}

const SebelPopUpInstance = new SebelPopUp();
SebelPopUpInstance.init();

export { SebelPopUp, SebelPopUpInstance };